import { useEffect, useState } from "react"
import { Space, Select, } from 'antd';
import { getSidoListAPI } from 'api/common';

export const AreaSearch = ({onSelect}) => {
    const [list, setList] = useState([])
    const [sido, setSido] = useState([])
    const [sigungu, setSigungu] = useState([])
    const [option, setOption] = useState({})

    useEffect(()=>{
       getSidoList()
    },[])

    const fnChangeSido = (e) => {
        setSido(e)
        let arr = e==='-1'? list : list.filter((it)=>it.SIDO_CODE === e)
        let sigungu = [{label:'전체', value: '-1'}]; 
        arr.map((item)=>{
            sigungu.push({label:item.GUGUN,value:item.GUGUN_CODE})
        })
        setOption({...option, sigunguOption:sigungu})
        onSelect(e, 'sido')
    }
    
    const fnChangeSigungu = (e) => {
        setSigungu(e)
        onSelect(e, 'sigungu_cd')
    }

    const getSidoList = async () => {
        try{
        await getSidoListAPI().then(res => {
            const array = res.data.data_list
            setList(res.data.data_list);
            let sidoCodeSet= new Set();
            let sidoNameSet= new Set();
            let sido=[{label:'전체', value: '-1'}];
            
            array.map((it)=>{
                sidoCodeSet.add(it.SIDO_CODE)
                sidoNameSet.add(it.SIDO)
            })
            const sidoCodeArr = [...sidoCodeSet];
            const sidoNameArr = [...sidoNameSet];

            for(let i=0; i<sidoCodeArr.length; i++){
                sido.push({label:sidoNameArr[i],value:sidoCodeArr[i]})
            }
            setOption({...option, sidoOption : sido})

        })
        }catch(err){
            console.log(err);
        }
  }

    return (<>
    <Space>
        <Select
            placeholder={'시도를 선택하세요'}
            value={sido}
            style={{ width: '15rem' }}
            options={option?.sidoOption}
            onSelect={fnChangeSido}
        />
        <Select
            placeholder={'시,군,구를 선택하세요'}
            value={sigungu}
            style={{ width: '16rem' }}
            options={option?.sigunguOption}
            onSelect={fnChangeSigungu}
        />  
    </Space>
    </>)
}
